/* QVA Giá Sỉ Nhà Vườn — opt-in checkbox. ISOLATED ADD-ON. v2 (mockup parity).
 *
 * Contract with the theme (Dawn 15.x):
 *  - Writes cart attribute qva_gia_si via POST /cart/update.js with
 *    sections=cart-drawer, animates the footer total from the old value to
 *    the server's new value, then swaps .drawer__inner with the returned
 *    section HTML (server truth).
 *  - NEVER publishes Dawn's cartUpdate pub/sub event: the CartItems
 *    subscriber would replaceWith() the footer mid-animation.
 *  - Dawn's own re-renders (qty change, add-to-cart) recreate this element
 *    from Liquid; state comes from cart.attributes, so nothing is lost.
 *  - Displayed money is never computed here. The animated target and the
 *    final text both come from the server-rendered section.
 *  - Tier-crossing celebration: each render stores the current tier rate in
 *    window.__qvaGiaSiRate; when a re-render arrives with a higher rate and
 *    the box is checked, fire confetti + a strong haptic. Confetti is
 *    reserved for tier crossings only.
 */
(function () {
  'use strict';
  if (customElements.get('qva-gia-si-optin')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DUR = 550;
  var cartMutationSequence = 0;
  var activeCartMutationTokens = new Set();
  var activeExternalCartMutationTokens = new Set();
  var anonymousExternalCartMutationDepth = 0;
  var cartFinancialSurfacesStale = false;
  var STALE_CART_MESSAGE =
    'Giỏ hàng có thể đã thay đổi nhưng chưa cập nhật trên màn hình. Vui lòng tải lại trang trước khi dùng Ví điểm hoặc thanh toán.';
  var STALE_CART_CONTROL_SELECTOR = [
    '[name="checkout"]',
    '.cart__dynamic-checkout-buttons',
    '[name="updates[]"]',
    '.quantity__button',
    'cart-remove-button',
    '.qva-optin__box',
    '.qva-sel',
    '.qva-sel-all',
    'td.cart-item__media',
    '[name="add"]',
    '.quick-add__submit',
    '.product-form__submit',
    '[data-qva-wallet] input',
    '[data-qva-wallet] button',
    '[data-qva-wallet] select',
    '[data-qva-wallet] textarea'
  ].join(',');

  function walletMutationIsBusy() {
    var documentElement = document.documentElement;
    var body = document.body;
    return !!(
      (documentElement && documentElement.getAttribute('data-qva-wallet-mutation-busy') === 'true') ||
      (body && body.getAttribute('data-qva-wallet-mutation-busy') === 'true')
    );
  }

  function externalCartMutationIsBusy() {
    var documentElement = document.documentElement;
    return !!(
      activeExternalCartMutationTokens.size ||
      anonymousExternalCartMutationDepth ||
      (
        activeCartMutationTokens.size === 0 &&
        documentElement &&
        documentElement.getAttribute('data-qva-cart-mutation-busy') === 'true'
      )
    );
  }

  function notifyWalletCartControlBlocked() {
    try {
      document.dispatchEvent(new CustomEvent('qva:wallet-cart-control-blocked', {
        detail: { source: 'wholesale' }
      }));
    } catch (e) { /* wholesale safety must not depend on the Wallet asset */ }
  }

  function blockStaleFinancialAction(event) {
    if (!cartFinancialSurfacesStale) return;
    var target = event && event.target && event.target.nodeType === 1 ? event.target : null;
    var control = null;
    if (event.type === 'submit') {
      var form = target;
      control = event.submitter && event.submitter.nodeType === 1 ? event.submitter : null;
      if (!control && form && form.querySelector(STALE_CART_CONTROL_SELECTOR)) control = form;
    } else if (target) {
      control = target.closest(STALE_CART_CONTROL_SELECTOR);
    }
    if (!control || (control.closest && control.closest('[data-qva-wallet-recovery-copy]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (control.matches && control.matches('[name="updates[]"]')) {
      var serverValue = control.getAttribute('value');
      if (serverValue !== null) control.value = serverValue;
    } else if (control.matches && control.matches('.qva-optin__box')) {
      var wholesaleCard = control.closest('qva-gia-si-optin');
      if (wholesaleCard) control.checked = wholesaleCard.dataset.checked === '1';
    } else if (control.matches && control.matches('.qva-sel')) {
      var lineInput = control.querySelector('input');
      if (lineInput) lineInput.checked = control.dataset.off === '0';
    } else if (control.matches && control.matches('.qva-sel-all')) {
      var allInput = control.querySelector('input');
      var selected = Number(control.dataset.selected || 0);
      var total = Number(control.dataset.total || 0);
      if (allInput) {
        allInput.checked = total > 0 && selected === total;
        allInput.indeterminate = selected > 0 && selected < total;
      }
    }
    ['CartDrawer-CartErrors', 'cart-errors'].forEach(function (id) {
      var error = document.getElementById(id);
      if (error) error.textContent = STALE_CART_MESSAGE;
    });
  }

  document.addEventListener('click', blockStaleFinancialAction, true);
  document.addEventListener('change', blockStaleFinancialAction, true);
  document.addEventListener('submit', blockStaleFinancialAction, true);

  function guardStaleForm(form) {
    if (!form) return;
    form.dataset.qvaCartStale = 'true';
    form.querySelectorAll('[name="updates[]"], .quantity__button, .qva-optin__box, .qva-sel input, .qva-sel-all input').forEach(function (control) {
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });
    if (form.dataset.qvaCartStaleSubmitGuard === 'true') return;
    form.dataset.qvaCartStaleSubmitGuard = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  function disableStaleFinancialSurfaces() {
    cartFinancialSurfacesStale = true;
    pendingIntent = null;
    if (document.documentElement) {
      document.documentElement.setAttribute('data-qva-cart-financial-state-stale', 'true');
    }

    guardStaleForm(document.getElementById('CartDrawer-Form'));
    guardStaleForm(document.getElementById('cart'));

    document.querySelectorAll([
      '[name="updates[]"]',
      '.quantity__button',
      'cart-remove-button',
      'cart-remove-button button',
      'cart-remove-button a',
      '.qva-optin__box',
      '[name="add"]',
      '.quick-add__submit',
      '.product-form__submit'
    ].join(',')).forEach(function (control) {
      if ('disabled' in control) control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });

    document.querySelectorAll('[name="checkout"]').forEach(function (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.removeAttribute('name');
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (container) {
      container.hidden = true;
    });
    document.querySelectorAll('[data-qva-wallet]').forEach(function (wallet) {
      wallet.dataset.qvaCartStale = 'true';
      wallet.setAttribute('aria-disabled', 'true');
      wallet.querySelectorAll('input, button, select, textarea').forEach(function (control) {
        if (!control.matches('[data-qva-wallet-recovery-copy]')) control.disabled = true;
      });
    });
    document.querySelectorAll('qva-gia-si-optin').forEach(function (card) {
      card.dataset.qvaCartStale = 'true';
      card.setAttribute('aria-disabled', 'true');
      var box = card.querySelector('.qva-optin__box');
      if (box) {
        box.disabled = true;
        box.setAttribute('aria-disabled', 'true');
      }
    });
    ['CartDrawer-CartErrors', 'cart-errors'].forEach(function (id) {
      var error = document.getElementById(id);
      if (error) error.textContent = STALE_CART_MESSAGE;
    });
  }

  function cartRenderRevision() { return Number(window.__qvaCartRenderRevision) || 0; }
  function markCartRendered() { window.__qvaCartRenderRevision = cartRenderRevision() + 1; }

  function syncCartMutationBusySignal() {
    var documentElement = document.documentElement;
    if (!documentElement) return;
    if (activeCartMutationTokens.size || activeExternalCartMutationTokens.size || anonymousExternalCartMutationDepth) {
      documentElement.setAttribute('data-qva-cart-mutation-busy', 'true');
    } else {
      documentElement.removeAttribute('data-qva-cart-mutation-busy');
    }
  }

  function beginCartMutation(source) {
    var token = source + ':' + Date.now() + ':' + (++cartMutationSequence);
    activeCartMutationTokens.add(token);
    // Level-triggered signal: the gateway can still see a mutation that began
    // before its deferred script registered the event listeners.
    syncCartMutationBusySignal();
    try {
      document.dispatchEvent(new CustomEvent('qva:cart-mutation-start', {
        detail: { token: token, source: source }
      }));
    } catch (e) { /* the cart update must not depend on the gateway */ }
    return token;
  }

  function finishCartMutation(token, source, completedState) {
    if (!token || !activeCartMutationTokens.delete(token)) return;
    syncCartMutationBusySignal();
    try {
      document.dispatchEvent(new CustomEvent('qva:cart-mutation-end', {
        detail: { token: token, source: source }
      }));
    } catch (e) { /* the cart update must not depend on the gateway */ }

    if (
      activeCartMutationTokens.size !== 0 ||
      pendingIntent === null ||
      walletMutationIsBusy() ||
      externalCartMutationIsBusy() ||
      cartFinancialSurfacesStale
    ) return;
    var want = pendingIntent;
    pendingIntent = null;
    if (completedState === want) return;

    var current = document.querySelector('qva-gia-si-optin');
    if (!current || typeof current.toggle !== 'function') {
      pendingIntent = want;
      return;
    }
    current.toggle(want, /*silent*/ true);
  }

  // A tap that lands while a cart request is in flight. Held at module scope on
  // purpose: applying the update replaces .drawer__inner, which destroys the
  // element the tap arrived on, so anything stored on `this` is lost with it.
  var pendingIntent = null;

  function replayPendingIntentAfterWallet() {
    if (
      pendingIntent === null ||
      activeCartMutationTokens.size !== 0 ||
      walletMutationIsBusy() ||
      externalCartMutationIsBusy() ||
      cartFinancialSurfacesStale
    ) return;
    var current = document.querySelector('qva-gia-si-optin');
    if (!current || typeof current.toggle !== 'function') return;
    var want = pendingIntent;
    pendingIntent = null;
    if ((current.dataset.checked === '1') === want) return;
    current.toggle(want, /*silent*/ true);
  }

  document.addEventListener('qva:cart-mutation-start', function (event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.source === 'wholesale') return;
    // Wallet already publishes its own protected busy signal. Mirroring it
    // into the generic cart signal makes Wallet mistake its own request for
    // a competing request and cancel before redemption.
    if (detail.source === 'wallet') return;
    if (detail.token) activeExternalCartMutationTokens.add(String(detail.token));
    else anonymousExternalCartMutationDepth += 1;
    syncCartMutationBusySignal();
  });

  document.addEventListener('qva:cart-mutation-end', function (event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.source === 'wholesale') return;
    if (detail.source !== 'wallet') {
      if (detail.token) activeExternalCartMutationTokens.delete(String(detail.token));
      else anonymousExternalCartMutationDepth = Math.max(0, anonymousExternalCartMutationDepth - 1);
      syncCartMutationBusySignal();
    }
    // Let every listener observe the mutation end before opening the deferred
    // wholesale token. The replay re-checks the level signal at execution.
    setTimeout(replayPendingIntentAfterWallet, 0);
  });

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function parseDigits(text) {
    var n = parseInt(String(text || '').replace(/\D/g, ''), 10);
    return isFinite(n) ? n : null;
  }

  function confettiBurst(originEl) {
    if (reducedMotion() || !document.body.animate) return;
    var host = document.createElement('div');
    host.style.cssText = 'position:fixed;inset:0;pointer-events:none;overflow:hidden;z-index:2147483000;';
    document.body.appendChild(host);
    var r = originEl && originEl.getBoundingClientRect
      ? originEl.getBoundingClientRect()
      : { left: innerWidth / 2 - 20, top: innerHeight / 2, width: 40, height: 0 };
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var colors = ['#e07b32', '#2f7d4f', '#e8b93f', '#c0392b', '#6f9a3c'];
    var alive = 0;
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('i');
      p.style.cssText = 'position:absolute;width:8px;height:12px;border-radius:2px;background:' +
        colors[i % colors.length] + ';left:' + cx + 'px;top:' + cy + 'px;';
      host.appendChild(p);
      var dx = (Math.random() - 0.5) * 340;
      var dy = -120 - Math.random() * 200;
      var rot = (Math.random() - 0.5) * 900;
      alive++;
      p.animate(
        [
          { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + 'deg)', opacity: 1, offset: 0.55 },
          { transform: 'translate(' + dx * 1.25 + 'px,' + (dy + 420) + 'px) rotate(' + rot * 1.4 + 'deg)', opacity: 0 }
        ],
        { duration: 1500 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.4,1)' }
      ).onfinish = function () { if (--alive === 0) host.remove(); };
    }
    setTimeout(function () { if (host.parentNode) host.remove(); }, 2600);
  }

  var QvaGiaSiOptin = /** @type {any} */ (function () {
    function El() { return Reflect.construct(HTMLElement, [], El); }
    El.prototype = Object.create(HTMLElement.prototype, { constructor: { value: El } });
    Object.setPrototypeOf(El, HTMLElement);

    El.prototype.connectedCallback = function () {
      var self = this;
      if (typeof this._busy !== 'boolean') this._busy = false;
      this._box = this.querySelector('.qva-optin__box');
      this._haptic = this.querySelector('.qva-optin__haptic input');
      if (!this._box) return;

      // Dawn's <cart-items> binds `change` on ITSELF, so anything that bubbles
      // up from inside the drawer is handed to validateQuantity(), which reads
      // .step / .min off event.target. For a checkbox that is NaN, and NaN % NaN
      // !== 0, so Dawn calls setCustomValidity() + reportValidity() on our box
      // and pops its own step-error string: "Bạn chỉ có thể thêm mặt hàng này
      // theo đơn vị giao dịch". Keep our events inside this element.
      // (The hidden iOS haptic switch fires `change` on .click() too — same trap.)
      if (!this._isolated) {
        this._isolated = true;
        ['change', 'input', 'keydown', 'keyup'].forEach(function (name) {
          self.addEventListener(name, function (ev) { ev.stopPropagation(); });
        });
      }

      if (this._boundBox !== this._box) {
        this._boundBox = this._box;
        this._box.addEventListener('change', function () { self.toggle(self._box.checked); });
      }

      // Tier-crossing celebration (confetti is reserved for this moment).
      var rate = parseInt(this.dataset.rate || '0', 10);
      var prev = window.__qvaGiaSiRate;
      window.__qvaGiaSiRate = rate;
      if (typeof prev === 'number' && rate > prev && this.dataset.checked === '1') {
        this.hapticTap(true);
        confettiBurst(this);
      }

      // TICKED BY DEFAULT (Aug 2026).
      //
      // The old build wrote '0' into the cart on first render, which switched
      // the discount OFF for every new cart and made the customer earn it back
      // with a click. Now the discount is on unless they turn it off.
      //
      // A missing attribute already means "apply" to the discount function, so
      // on a fresh cart there is nothing to write — the money is off the total
      // before this script runs, and the card renders ticked to match. Doing
      // nothing here also saves a cart round trip on every first drawer open.
      //
      // remembered is now tri-state. It has to be: false alone cannot tell
      // "never chose" apart from "chose to opt out", and that ambiguity is
      // exactly what made the old default silently wrong.
      var remembered = null;
      try {
        var raw = localStorage.getItem('qva_gia_si');
        if (raw === '1' || raw === '0') remembered = raw;
      } catch (e) { /* private mode */ }

      // Honour a tap that arrived while the previous request was still going.
      // Do this before anything else: it is the customer's most recent
      // instruction and it outranks any remembered preference.
      if (
        pendingIntent !== null &&
        activeCartMutationTokens.size === 0 &&
        !walletMutationIsBusy() &&
        !externalCartMutationIsBusy()
      ) {
        var want = pendingIntent;
        pendingIntent = null;
        if ((this.dataset.checked === '1') !== want) {
          this.toggle(want);
          this.bindCheckoutGuard();
          return;
        }
      }

      // NOTE: a fresh cart used to trigger a silent toggle(false) here when the
      // customer had opted out before. It fired on every first drawer open,
      // held _busy for the whole round trip, and any tap in that window was
      // eaten — the reported "tick pops back up" bug. It is gone. A new cart
      // now simply starts with the discount on, which is the default we want
      // anyway; a stale opt-out is not worth a background request, and it only
      // ever withheld money from the customer.
      if (this.dataset.attrstate !== 'none' && this.dataset.checked !== '1' && remembered === '1') {
        // This cart says off but the customer opted in before (another device,
        // or the cart was rebuilt). Restore their choice.
        this.toggle(true, /*silent*/ true);
      }

      this.bindCheckoutGuard();
    };

    El.prototype.hapticTap = function (strong) {
      if (typeof navigator.vibrate === 'function' && navigator.vibrate(strong ? [14, 28, 14] : 9)) return;
      try { if (this._haptic) this._haptic.click(); } catch (e) { /* no haptics */ }
    };

    El.prototype.toggle = function (on, silent) {
      var self = this;
      if (cartFinancialSurfacesStale) {
        if (this._box) this._box.checked = this.dataset.checked === '1';
        return;
      }
      if (this._busy || activeCartMutationTokens.size !== 0) {
        // Do NOT revert the box. That is what made unticking take three or four
        // taps: every tap inside the in-flight window was silently undone, so
        // the tick appeared to spring straight back. Remember what was asked
        // for and apply it when the current round trip lands.
        pendingIntent = !!on;
        return;
      }
      if (walletMutationIsBusy()) {
        // Wallet is using the current subtotal for an irreversible redemption.
        // Keep the UI on server truth and replay the requested wholesale state
        // only after Wallet's protected token is fully released.
        pendingIntent = !!on;
        if (this._box) this._box.checked = this.dataset.checked === '1';
        if (!silent) notifyWalletCartControlBlocked();
        return;
      }
      if (externalCartMutationIsBusy()) {
        pendingIntent = !!on;
        if (this._box) this._box.checked = this.dataset.checked === '1';
        return;
      }
      this._busy = true;
      var mutationToken = beginCartMutation('wholesale');
      var revisionAtStart = cartRenderRevision();
      if (!silent) this.hapticTap(false);
      try { localStorage.setItem('qva_gia_si', on ? '1' : '0'); } catch (e) {}

      var body = JSON.stringify({
        attributes: { qva_gia_si: on ? '1' : '0' },
        sections: 'cart-drawer'
      });

      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/update.js HTTP ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          if (cartRenderRevision() !== revisionAtStart) {
            self._busy = false;
            finishCartMutation(mutationToken, 'wholesale', on);
            return;
          }
          var drawer = document.getElementById('CartDrawer');

          // Look the drawer up in the DOCUMENT, not from `self`.
          // `self` is the element that was clicked, and by the time this
          // response lands Dawn may already have rebuilt .drawer__inner and
          // thrown that element away. A detached node's closest('#CartDrawer')
          // returns null, which used to send us down the reload path — on a
          // phone, where the round trip is slow enough for that race to be
          // routine, unticking dumped the customer out of the drawer and back
          // onto whatever page they were browsing.
          // No drawer anywhere means we really are on /cart, where a reload is
          // the right answer because the animated swap targets don't exist.
          if (!drawer) {
            self._busy = false;
            finishCartMutation(mutationToken, 'wholesale', on);
            window.location.reload();
            return;
          }

          var html = cart.sections && cart.sections['cart-drawer'];
          if (!html) { self.hardRefresh('no-section', mutationToken, on); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshInner = doc.querySelector('.drawer__inner');
          var oldInner = drawer.querySelector('.drawer__inner');
          if (!freshInner || !oldInner) { self.hardRefresh('no-inner', mutationToken, on); return; }

          var totalNode = oldInner.querySelector('.totals__total-value');
          var newTotalNode = freshInner.querySelector('.totals__total-value');
          var from = totalNode ? parseDigits(totalNode.textContent) : null;
          var to = newTotalNode ? parseDigits(newTotalNode.textContent) : null;
          var finalText = newTotalNode ? newTotalNode.textContent : null;

          var swap = function () {
            try {
              if (!oldInner.isConnected || (totalNode && !totalNode.isConnected)) return;
              oldInner.innerHTML = freshInner.innerHTML;
              markCartRendered();
              document.documentElement.classList.add('qva-optin-postswap');
              setTimeout(function () {
                document.documentElement.classList.remove('qva-optin-postswap');
              }, 600);
            } finally {
              document.documentElement.classList.remove('qva-optin-animating');
              self._busy = false;
              finishCartMutation(mutationToken, 'wholesale', on);
            }
          };

          if (silent || reducedMotion() || from === null || to === null || from === to || !totalNode) {
            swap();
            return;
          }

          // Count the visible total from old to new, then swap in server truth.
          document.documentElement.classList.add('qva-optin-animating');
          var sample = finalText || totalNode.textContent;
          var suffix = /VND\s*$/.test(sample) ? ' VND' : '₫';
          var t0 = performance.now();
          (function step(now) {
            if (!totalNode.isConnected) {
              document.documentElement.classList.remove('qva-optin-animating');
              self._busy = false;
              finishCartMutation(mutationToken, 'wholesale', on);
              return;
            } // a newer cart render is already visible; never overwrite it with this older section
            var p = Math.min(1, (now - t0) / DUR);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = Math.round((from + (to - from) * eased) / 100);
            totalNode.textContent = new Intl.NumberFormat('vi-VN').format(val) + suffix;
            if (p < 1) { requestAnimationFrame(step); }
            else { totalNode.textContent = finalText; setTimeout(swap, 120); }
          })(t0);
        })
        .catch(function () { self.hardRefresh('network', mutationToken, null); });
    };

    // Fallback: something unexpected happened. The old version called
    // window.location.reload() here — correctness over smoothness. On a phone
    // that reads as "the app threw me out": the drawer vanishes and you are
    // back on the page you started from, with the checkbox looking untouched.
    //
    // Re-render the drawer from the server instead. Same correctness guarantee
    // (the markup comes from Shopify, not from us) with none of the whiplash,
    // and the customer keeps their place. If even that fails we leave the cart
    // alone, make every stale financial action inert, and require a reload.
    // A response-lost POST may already have committed, so allowing Wallet or
    // checkout to use the old subtotal would be unsafe.
    El.prototype.hardRefresh = function (why, mutationToken, requestedState) {
      var self = this;

      var showFailure = function () {
        disableStaleFinancialSurfaces();
        var sub = self.querySelector('.qva-optin__t2');
        if (sub) {
          sub.hidden = false;
          sub.textContent = STALE_CART_MESSAGE;
        }
        self._busy = false;
        finishCartMutation(mutationToken, 'wholesale', null);
      };

      fetch(ROOT + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
        .then(function (sections) {
          var html = sections && sections['cart-drawer'];
          var drawer = document.getElementById('CartDrawer');
          var oldInner = drawer && drawer.querySelector('.drawer__inner');
          if (!html || !oldInner) { showFailure(); return; }
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
          if (!fresh) { showFailure(); return; }
          oldInner.innerHTML = fresh.innerHTML;
          markCartRendered();
          self._busy = false;
          var freshCard = fresh.querySelector('qva-gia-si-optin');
          var serverState = freshCard ? freshCard.dataset.checked === '1' : requestedState;
          finishCartMutation(mutationToken, 'wholesale', serverState);
        })
        .catch(showFailure);
    };

    El.prototype.bindCheckoutGuard = function () {
      var self = this;
      var form = this.closest('form');
      var scope = form || document.getElementById('CartDrawer') || document;
      var btn = scope.querySelector('[name="checkout"]');
      if (!btn || btn.dataset.qvaGuard === '1') return;
      btn.dataset.qvaGuard = '1';
      btn.addEventListener('click', function (ev) {
        var card = document.querySelector('qva-gia-si-optin');
        var box = card && card.querySelector('.qva-optin__box');
        if (!card || !box || box.checked || card.dataset.qvaWarned === '1') return;
        ev.preventDefault();
        ev.stopPropagation();
        card.dataset.qvaWarned = '1';
        self.hapticTap(true);
        card.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
        var sub = card.querySelector('.qva-optin__t2');
        if (sub) {
          sub.hidden = false;
          var amt = card.dataset.potential;
          sub.innerHTML = amt
            ? 'Bạn đang bỏ lỡ <strong>' + amt + '</strong> — bấm ô này để nhận'
            : 'Bạn đang bỏ lỡ ưu đãi <strong>giảm ' + (card.dataset.rate || '') + '%</strong> — bấm ô này để nhận';
        }
        if (card.animate) {
          card.animate(
            [{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' },
             { transform: 'translateX(7px)' }, { transform: 'translateX(0)' }],
            { duration: 340 }
          );
        }
      }, true);
    };

    return El;
  })();

  customElements.define('qva-gia-si-optin', QvaGiaSiOptin);
})();
